<template>
  <rest-page
    :fetch-endpoint="fetchEndpoint"
    layout="tabbed"
    :style="customStyle"
  >
    <page-header
      :title="title"
      :breadcrumbs="breadcrumbs"
      :description="description"
      :icon="icon"
    >
      <template slot="actions">
        <a
          v-if="Integrations[this.$route.query.type].urls.guide"
          :href="Integrations[this.$route.query.type].urls.guide"
          target="_blank"
        >
          <el-button type="primary" plain>
            {{ $t('Integrations_Button_Guide') }}
          </el-button>
        </a>

        <el-button
          type="primary"
          @click="save"
          v-if="finalStep"
          :disabled="!isAllowedToContinue"
        >
          {{ $t('Integrations_Button_Connect') }}
        </el-button>
        <el-button type="primary" plain @click="nextStep" v-if="!finalStep">{{
          $t('Integrations_Button_Next')
        }}</el-button>
      </template>
    </page-header>

    <page-steps
      ref="stepper"
      @can-continue-updated="canContinueUpdated"
      @next-button-updated="updateNextButton"
      @final-step-updated="updateFinalStep"
      :steps="steps"
      :model="model"
      :rules="rules"
      :save-endpoint="saveEndpoint"
      :after-save="afterSave"
      :is-edit="isEdit"
      :readonly="readonly"
    />
  </rest-page>
</template>

<script>
import RestPage from '@/common/components/rest/RestPage'
import PageHeader from '@/common/components/page/PageHeaderNew'
import PageSteps from '@/common/components/page/PageSteps'
import Integrations from '@/modules/integrations/types'

export default {
  name: 'IntegrationCreatePageStepped',

  components: {
    RestPage,
    PageHeader,
    PageSteps
  },

  props: {
    title: {
      type: String,
      required: true
    },

    steps: {
      type: Array,
      required: true
    },

    breadcrumbs: {
      type: Array,
      required: false,
      default: () => []
    },

    model: {
      type: Object,
      required: true
    },

    props: {
      type: Object,
      required: false
    },

    fetchEndpoint: {
      type: [Object, Array],
      required: false,
      default: {}
    },

    saveEndpoint: {
      type: Object,
      required: true
    },
    afterSave: {
      type: Function,
      required: false
    },

    rules: {
      type: Object,
      required: true
    },

    isEdit: {
      type: Boolean,
      default: false,
      required: false
    },

    readonly: {
      type: Boolean,
      default: false,
      required: false
    },

    saveButton: {
      type: String,
      required: false
    },

    nextStepButton: {
      type: String,
      required: false
    },

    icon: {
      type: String,
      required: false
    },

    description: {
      type: String,
      required: false
    }
  },

  data() {
    return {
      nextButton: {},
      finalStep: false,
      isAllowedToContinue: false,
      Integrations,
      customStyle: {
        backgroundColor: '#f2f5f9'
      }
    }
  },

  methods: {
    nextStep() {
      this.$refs.stepper
        .validate()
        .then(valid => {
          if (valid) {
            this.$refs.stepper.completeStep(
              this.$refs.stepper.currentStep.index
            )
            this.$refs.stepper.proceed({ value: true })
            this.$refs.stepper.nextStep()
          }
        })
        .catch(error => {
          let errors = Object.values(error).map(e => e[0].field)
          return errors
        })
    },

    updateNextButton(newValue) {
      Object.assign(this.nextButton, newValue)
    },

    updateFinalStep(newValue) {
      this.finalStep = newValue
    },

    canContinueUpdated(newValue) {
      this.isAllowedToContinue = newValue
    },

    save() {
      this.$refs.stepper.save()
    }
  },

  computed: {
    stepsCompleted() {
      return this.steps.every(element => element.completed === true)
    },

    isLastStep() {
      if (this.$refs.stepper) {
        return this.$refs.stepper.finalStep
      } else {
        return false
      }
    },

    currentStep() {
      return this.$refs.stepper.currentStep
    }
  }
}
</script>

<style scoped>
>>> .page,
>>> .page.layout-tabbed,
>>> .steps-content-layout,
>>> .step-item.active-class {
  background-color: #f2f5f9 !important;
}
</style>



// WEBPACK FOOTER //
// src/common/components/page/IntegrationCreatePageStepped.vue